// ASM inbox actions — call the asm-approve / asm-reject edge functions.
// Both endpoints require a Supabase user session; the Authorization header
// comes from the active session token.
//
// JSON parsing routes through readEdgeJson so a proxied HTML response
// (carrier 404, Private Relay, etc.) surfaces as a friendly network error
// instead of a cryptic SyntaxError. The fetch itself routes through
// fetchEdge so a dropped/aborted connection (iOS Safari "Load failed",
// Chrome "Failed to fetch", etc.) surfaces the same friendly message
// instead of the bare TypeError. Both helpers live in lib/edgeError.ts.
import { supabase, SUPABASE_URL } from "./supabase";
import { fetchEdge, readEdgeJson, sanitizeUserMessage } from "./edgeError";

async function authHeader(): Promise<string> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error("Not signed in");
  return `Bearer ${token}`;
}

export async function approveDeal(dealId: string, actorId: string | null) {
  const res = await fetchEdge(`${SUPABASE_URL}/functions/v1/asm-approve`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: await authHeader(),
    },
    body: JSON.stringify({ deal_id: dealId, actor_id: actorId }),
  });
  const body = await readEdgeJson<{ ok?: boolean; error?: string }>(res);
  if (!res.ok || body.ok === false) {
    throw new Error(sanitizeUserMessage(body.error, `Approve failed (HTTP ${res.status})`));
  }
  return body;
}

export async function rejectDeal(
  dealId: string,
  reason: string,
  actorId: string | null,
) {
  const res = await fetchEdge(`${SUPABASE_URL}/functions/v1/asm-reject`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: await authHeader(),
    },
    body: JSON.stringify({ deal_id: dealId, reason, actor_id: actorId }),
  });
  const body = await readEdgeJson<{ ok?: boolean; error?: string }>(res);
  if (!res.ok || body.ok === false) {
    throw new Error(sanitizeUserMessage(body.error, `Reject failed (HTTP ${res.status})`));
  }
  return body;
}
